import { render, staticRenderFns } from "./TenantDetail.vue?vue&type=template&id=5ffeda9d&scoped=true&"
import script from "./TenantDetail.vue?vue&type=script&lang=js&"
export * from "./TenantDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffeda9d",
  null
  
)

export default component.exports